var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"sj-loading",style:({
    zIndex: _vm.zIndex
  })},[_c(("theme" + _vm.theme),{tag:"component"}),(_vm.text)?_c('p',{staticClass:"sj-loading-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }